import { render, staticRenderFns } from "./DetalhesCargo.vue?vue&type=template&id=66bda2a2&scoped=true"
import script from "./DetalhesCargo.vue?vue&type=script&lang=js"
export * from "./DetalhesCargo.vue?vue&type=script&lang=js"
import style0 from "./DetalhesCargo.vue?vue&type=style&index=0&id=66bda2a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bda2a2",
  null
  
)

export default component.exports